import MainBody from "../../components/MainBody/MainBody";
// import ChartAreaInteractive from "./ChartAreaInteractive";
// import StatsCards from "./StatsCards";

const AdminDashboard = () => {
  return (
    <MainBody search={false}>
      <div>
        {/* <StatsCards /> */}
        <div className="mt-6">
          {/* <ChartAreaInteractive /> */}
        </div>
      </div>
    </MainBody>
  );
};

export default AdminDashboard;
